import React, { useLayoutEffect } from 'react';
import BrowserRouter from "./routes"
//var cors = require('cors')
// import Header from './Header';
// import Menu from './Menu';
// import Footer from './Footer';
// import Content from './Content';

 
const App = () => {
  useLayoutEffect(() => {
    const temaSalvo = localStorage.getItem("tema");

    if (!temaSalvo) {
      // Primeiro acesso: define dark como padrão
      document.body.classList.add("dark-mode");
      localStorage.setItem("tema", "dark");
    } else {
      // Aplica tema salvo
      if (temaSalvo === "dark") {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }
    }
  }, []);

  return <BrowserRouter />;
};

export default App;


// export default class App extends Component {
//   render() {
//     return (
//       <div>
//       <Header />
//       <Menu/>
//       <Content/>
//       <Footer/>
//       </div>
//     )
//   }
// }
